
    var riot = require('riot')
    riot.tag2('gb-sayt-autocomplete', '<yield> <gb-sayt-categories></gb-sayt-categories> <gb-sayt-divider></gb-sayt-divider> <gb-sayt-search-terms></gb-sayt-search-terms> <gb-sayt-divider></gb-sayt-divider> <gb-sayt-refinements each="{navigation in $sayt.navigations}"></gb-sayt-refinements> </yield>', 'gb-sayt-autocomplete.gb-stylish,[data-is="gb-sayt-autocomplete"].gb-stylish{ min-width: 210px; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-autocomplete.tag.html